export default __webpack_public_path__ + "static/aml-screening-e23007d91890738709929646fcddddd3.png";